import PESService from 'App/services/PESService';
import toast from 'Shared/toast';
import { useMutation, useQueryClient } from 'react-query';
import { errorHandler } from 'App/utils';

function useSaveWorkQueueFilterMutation() {
    const queryClient = useQueryClient();

    return useMutation((reqBody) => PESService.saveFilter(reqBody), {
        onError: errorHandler,
        onSuccess: async (data) => {
            toast.success('Filter has been saved successfully.');
            const { filterType } = (Object.values(data) || [])[0] || {};
            await queryClient.setQueryData(['workQueue', 'savedFilters', filterType], Object.values(data ?? {}));
        },
    });
}

export default useSaveWorkQueueFilterMutation;
